<header>
  <div class="">
    <div class="logo-login ">
      <div class="logo-login-main">
        <div class="img-logo">
          <img style="width: 65px; height: 65px; margin-top: -5px;"
            src="./assets/img/logo-projects/emblemofnorthvietnam.png">
        </div>
        <div class="title-logo">
          <div class="title-red">
          </div>
          <div class="title-blue">
            <P>BỘ GIÁO DỤC VÀ ĐÀO TẠO</P>
            <P>QUẢN LÝ GIÁO DỤC NGƯỜI KHUYẾT TẬT VIỆT NAM</P>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<section>
  <div class="nz-row height-100">
    <div class="height-100">
      <div class="notification-login flex ">
        <div nz-col [nzSpan]="18">
          <img class="ncseclass" src="./assets/img/logo-projects/ncse.png">
        </div>
        <!--Login-->
        <div nz-col [nzSpan]="6" [nzPull]="0">
          <div class="bg-color-login-user height-100">
            <div class="login-user text-center" *ngIf="!formLoginOpened" id="pageLoginInit">
              <div class="login-title">
                <p data-toggle="modal" data-target="#myModal">Chọn tài khoản đăng nhập</p>
              </div>
              <div class="img-login logoLogin">
                <img src="assets/login/images/Layer 5.png">
              </div>
              <div class="button-login">
                <a href="#" (click)="openLoginForm('Sở giáo dục')" class="ChangeQuanLy"><img
                    src="assets/login/images/login01.png">đơn vị quản lý cấp Tỉnh/thành phố</a>
              </div>

              <div class="button-login">
                <a href="#" (click)="openLoginForm('Giáo viên')"><img src="assets/login/images/login03.png">Giáo
                  viên</a>
              </div>

            </div>
            <div class="login-user text-center" *ngIf="formLoginOpened" id="pageLoginRedirect">
              <form class="form" [formGroup]="loginForm" (ngSubmit)="login()">
                <div class="login-title">
                  <p>Đăng nhập tài khoản</p>
                  <p style="text-transform:uppercase">{{typeUserLoginName}}</p>
                </div>
                <div class="img-login logoLogin">
                  <img src="assets/login/images/Layer 5.png">
                </div>
                <div class="login-user" [ngClass]="{'alert-validate': validate('username')}"
                  data-validate="Tên đăng nhập là bắt buộc">
                  <input type="text" id="userid" formControlName="username" placeholder="Tên đăng nhập">
                  <br>
                </div>
                <div class="login-pass validate-input" [ngClass]="{'alert-validate': validate('password')}"
                  data-validate="Mật khẩu là bắt buộc">
                  <input type="password" [type]="hidePassword ? 'password' : 'text'" formControlName="password"
                    id="password" placeholder="Mật khẩu">
                </div>
                <div class="login-pass">
                  <span id="message"></span>
                </div>
                <div class="login-submit">
                  <button>
                    Đăng nhập
                    <i class="fa fa-spinner fa-spin" *ngIf="loadingLogin"></i>
                  </button>
                </div>
              </form>
              <div class="survey">
                <div class="arrow left">
                  <button nz-button nzType="text" (click)="handlerPreSlide()">
                    <i nz-icon nzType="left" nzTheme="outline"></i>
                  </button>
                </div>
                <div class="arrow right">
                  <button nz-button nzType="text" (click)="handlerNextSlide()">
                    <i nz-icon nzType="right" nzTheme="outline"></i>
                  </button>
                </div>
                <nz-carousel #myCarousel (nzBeforeChange)="carouselChange($event)" (click)="handlerCarousel()"
                  class="cursor-pointer" nzAutoPlay>
                  <div nz-carousel-content *ngFor="let index of arraySurvey" [routerLink]="['/',  index.link]"
                    class="content-survey">
                    <span class="title">
                      {{ index.title }}
                    </span>
                    <img [src]="index.img" width="90%">
                  </div>
                </nz-carousel>
              </div>

              <div class="forgotPass">
                <a [routerLink]="['/resetmatkhau']"><p>Quên mật khẩu</p></a>
              </div>

            </div>
            <div class="login-support-main">
              <div class="login-contact">

                <a><i class="fa fa-phone-square" aria-hidden="true"></i>Thông tin hỗ trợ</a>
              </div>
              <div class="login-support">
                <strong><p>Hướng dẫn sử dụng:  <a href="http://hotro.ncse.edu.vn/" style="color:blue; text-decoration: underline">hotro.ncse.edu.vn</a></p></strong>
                <p>Hotline: (028) 2212 2696</p>
                <p>Email: support@ascvn.com.vn</p>
                <p>Website: <a href="http://qlkh.ascvn.com.vn" target="_blank">qlkh.ascvn.com.vn</a></p>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>

</section>
<footer>
  <div class="container-fuild">
    <div class="copyright-login text-center">
      <p></p>
    </div>
  </div>
</footer>
